import { NavLink } from 'react-router'
import { FiArrowRight, FiHeart } from 'react-icons/fi'
import { Container, Reveal, RevealGroup, HoverText } from '@/components/common'
import { ROUTES } from '@/constants/routes'
import { humanitarianProjects } from '@/constants/humanitarian-projects'

export const HumanitarianProjects = () => {
  return (
    <section className="bg-surface py-24 lg:py-32">
      <Container>
        {/* Section header */}
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Donation Projects <span className="text-ibon-dark/30">making a difference</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-8 text-lg leading-relaxed text-text-muted">
              IBON World runs targeted donation drives throughout the year, putting resources
              directly into the hands of children, orphans, and vulnerable communities across Ghana.
            </p>
          </Reveal>
        </div>

        {/* Project cards */}
        <RevealGroup className="mt-16 grid gap-8 sm:grid-cols-2" step={120}>
          {humanitarianProjects.map((project) => (
            <article
              key={project.id}
              className="group flex flex-col border border-border bg-white transition-colors duration-500 hover:border-ibon-sky/50"
            >
              {/* Card body */}
              <div className="flex flex-1 flex-col p-8">
                <span className="text-xs font-semibold uppercase tracking-[0.2em] text-ibon-sky">
                  {project.month} Drive
                </span>

                <h3 className="mt-3 text-2xl font-bold leading-snug tracking-tight text-ibon-dark">
                  {project.title}
                </h3>

                <p className="mt-2 text-base font-medium italic text-ibon-dark/60">
                  {project.tagline}
                </p>

                <p className="mt-4 flex-1 text-base leading-relaxed text-text-muted">
                  {project.description}
                </p>

                <NavLink
                  to={ROUTES.DONATE}
                  className="group/btn mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-ibon-sky px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-ibon-dark transition-colors hover:bg-[#6fcdef]"
                >
                  <HoverText text="Donate Now " />
                  <FiArrowRight
                    className="transition-transform duration-300 group-hover/btn:translate-x-1"
                    size={14}
                  />
                </NavLink>
              </div>
            </article>
          ))}
        </RevealGroup>

        {/* Bottom note */}
        <Reveal variant="up" delay={160}>
          <div className="mt-12 flex items-start gap-4 border-t border-border pt-8">
            <FiHeart className="mt-0.5 shrink-0 text-ibon-sky" size={20} />
            <p className="max-w-2xl text-base leading-relaxed text-text-muted">
              Every donation is handled with full{' '}
              <span className="font-semibold text-ibon-dark">transparency and accountability</span>.
              Your support goes directly to the people who need it most.
            </p>
          </div>
        </Reveal>
      </Container>
    </section>
  )
}
